import {ellipsis} from 'polished';
import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {VisualRecipientModel} from '../../../../../models/api/visualRecipientModel';
import {TimelineVariationsEnum} from '../../../../../store/timelineVariations/timelineVariationSelectors';
import {ThreeDots} from '../../../../common/threeDots';
import {MessageBase} from '../message/messageBase';

/*
 * Props.
 */

export interface ChatPrecogProps {
  recipient?: VisualRecipientModel;
  timelineVariation: TimelineVariationsEnum;
}

interface StyledPrecogContainerProps {
  $timelineVariation: TimelineVariationsEnum;
}

/*
 * Style.
 */

const StyledPrecogContainer = styled.div<StyledPrecogContainerProps>`
  display: flex;
  justify-content: ${(p) =>
    p.$timelineVariation === TimelineVariationsEnum.SYNCHRONOUS ? 'flex-start' : 'flex-end'};
  margin-top: 16px;
`;

const StyledPrecogDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  height: 42px;
`;

const StyledSideDiv = styled.div`
  flex-shrink: 0;
  margin: 8px;
  margin-left: 4px;
`;

const StyledTextDiv = styled.div`
  margin: 8px;
  color: ${(p) => p.theme.greys.shade70};
  ${ellipsis()};
  line-height: normal;
`;

const StyledMessageDiv = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 100%;
`;

/*
 * Component.
 */

export const ChatPrecog = (props: ChatPrecogProps) => {
  const theme = useUserTheme();

  return (
    <StyledPrecogContainer $timelineVariation={props.timelineVariation}>
      <StyledMessageDiv>
        <MessageBase timelineVariation={props.timelineVariation}>
          <StyledPrecogDiv>
            <StyledTextDiv>{renderText(props)}</StyledTextDiv>
            <StyledSideDiv>
              <ThreeDots color={theme.greys.shade60} size={VisualSizesEnum.MEDIUM} />
            </StyledSideDiv>
          </StyledPrecogDiv>
        </MessageBase>
      </StyledMessageDiv>
    </StyledPrecogContainer>
  );
};

function renderText(props: ChatPrecogProps) {
  const {recipient} = props;

  if (!recipient || !recipient.name) {
    return <Trans id="message-chat-precog-unknown">Visitor is replying</Trans>;
  }

  return <Trans id="message-chat-precog-one">{recipient.name} is replying</Trans>;
}
